import React from "react";

const Producto = ({ producto }) => {
  if (Object.keys(producto) === null || producto.adicionales === undefined)
    return null;

  return (
    <div className="tarjeta border">
      <div className="card-header titulo-producto">{producto.nombre}</div>
      <img src={producto.images} className="card-img-top" alt="..." />
      <div className="card-body">
        <h5 className="card-title">DETALLES</h5>
        <p className="card-text">
          {producto.descripcion}
          <br />
          <strong>Ingredientes:</strong> {producto.ingredientes}
        </p>
        <strong>Tamaño:</strong>
        <ul className="list-group">
          {producto.adicionales.map((adicional, index) => (
            <li key={index} className="list-group-item tamanio-producto">
              <span>{adicional.tamanio}</span> <span>${adicional.precio}</span>{" "}
              <span>
                {" "}
                {adicional.personas}{" "}
                <i className="fa fa-child" aria-hidden="true"></i>
              </span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Producto;
